import { environment } from 'src/environments/environment';
export const constants = {
   AWS_URL: `https://s3-${environment.AWS_REGION}.amazonaws.com/${environment.AWS_BUCKET}/`
};